import { Component, OnInit } from '@angular/core';
import { RootScopeService } from '../../../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../../../core/rootscope-declare';
import { Subscription } from 'rxjs';
import { FacilityService } from '../../../../core/services/facility.service';
import { environment } from '../../../../../environments/environment';
import { AddBodyserialService } from '../../../services/add-bodyserial.service';
import { Router } from '@angular/router';
import { MultiFacilityService } from 'src/app/post-login/services/multi-facility.service';
import { HaloLoaderService } from 'src/app/core/halo-loader/halo-loader.service';
import { CommonUtil } from 'src/app/core/Utils/common-util';
import { AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';

@Component({
  selector: 'app-add-old-equipment',
  templateUrl: './add-old-equipment.component.html',
  styleUrls: ['./add-old-equipment.component.scss'],
})
export class AddOldEquipmentComponent implements OnInit {
  rootScopeData: RootScopeDeclare;
  private sub = new Subscription();
  currentFacility: any;
  cloudBasePath: string;
  displayStep: number;
  bodySerial: string;
  UUID:string;
  isSerialNumberError: boolean = false;
  serialNumberErrorType: number;
  isBodySerialValid: string;
  connectedStrength = false;
  errorType: string;
  addequipmentdata: any;
  showUnsavedModal: boolean = false;
  constructor(
    private rootScopeService: RootScopeService,
    private multiFacService: MultiFacilityService,
    private _facilityService: FacilityService,
    private _addbodyserial: AddBodyserialService,
    private router: Router,
    private _ampAnalytics: AmplitudeAnalyticsService,
    private loader: HaloLoaderService,
    public commonUtil: CommonUtil,
  ) {}


  setPageName(): void {
    this.rootScopeData.pageName = 'Facility - Equipment';
  }

  ngOnInit() {
    this._ampAnalytics.logEvent({elementName: 'Page', action: 'Loaded', additionalProperty: {subFeatureName: 'Add Old Equipment'}});
    const rootScopeSub = this.rootScopeService.getRootScope().subscribe((rootScopeData) => (this.rootScopeData = rootScopeData));
    this.sub.add(rootScopeSub);

    this.setPageName();
    this.currentFacility = this._facilityService.selectedFacility();
    this.cloudBasePath = environment.cloudBasePath;

    const facilitySub = this._facilityService.selectedFacilitySource.subscribe((res) => {
      this.currentFacility = res;
      this._resetAddEquipment();
    });
    this.sub.add(facilitySub);

    this._resetAddEquipment();
  }

  private _resetAddEquipment() {
    this.displayStep = 1;
    this.bodySerial = '';
    this.isSerialNumberError = false;
    this.serialNumberErrorType = 0;
    this.errorType = '';
  }

  verifyBodySerial() {
    if (this.bodySerial == '' || this.bodySerial == undefined) {
      this.isSerialNumberError = true;
      this.serialNumberErrorType = 4;
      this.errorType = 'PLEASE.ENTER.SERIAL.NO.MAC.ADDRESS';
      return false;
    }

    this.checkBodySerialValid(this.bodySerial);
    if (this.isBodySerialValid === 'true') {
      const verifyBodySerialSub = this._addbodyserial.verifyBodySerial(this.currentFacility.facilityId, this.bodySerial, this.connectedStrength).subscribe(
        (data) => {
          this.addequipmentdata = data;
          this.UUID = data.bodySerial?data.bodySerial:data.displayBodySerial;
          this.displayStep = 2;
        },
        (error) => {
          let errorCode;
          let errorMessage = error.error;
          if(typeof errorMessage !== 'object'){
            errorCode = errorMessage.substring(
              errorMessage.indexOf('Code: ') + 6,
              errorMessage.indexOf('Code: ') + 9
            );
          }else{
            errorCode = errorMessage.errorCode;
          }
   
          if (errorCode.toString() == '307') {
            this.serialNumberErrorType = 1;
            this.errorType = 'EQUIPMENT.NOT.CONNECTED.INTERNET.MSG';
            this.isSerialNumberError = true;
          } else if (errorCode.toString() == '308') {
            this.serialNumberErrorType = 3;
            this.errorType = 'SERIAL.NUMBER.ALREADY.ASSOCIATED.TO.YOUR.FACILITY.MSG';
            this.isSerialNumberError = true;
          } else if (errorCode.toString() == '309') {
            this.serialNumberErrorType = 2;
            this.errorType = 'SERIAL.NUMBER.ASSOCIATED.WITH.ANOTHER.FACILITY.MSG';
            this.isSerialNumberError = true;
          } else if (errorCode.toString() == '305') {
            this.serialNumberErrorType = 5;
            this.errorType = 'PLEASE.ENTER.VALID.SERIAL.NUMBER';
            this.isSerialNumberError = true;
          } else if (errorCode.toString() == '306') {
            this.serialNumberErrorType = 6;
            this.errorType = 'SERIAL.NUMBER.IP.MISMATCH.MSG';
            this.isSerialNumberError = true;
          } else if (errorCode.toString() === '304') {
            this.serialNumberErrorType = 5;
            this.errorType = 'FACILITY.ALREADY.ASSOCIATED.WITH.USER';
            this.isSerialNumberError = true;
          }
        }
      );
      this.sub.add(verifyBodySerialSub);
      return false;
    } else {
      this.isSerialNumberError = true;
      this.serialNumberErrorType = 5;
      this.errorType = 'PLEASE.ENTER.VALID.SERIAL.NUMBER';
      return false;
    }
  }

  checkBodySerialValid(bodySerial: string) {
    this.connectedStrength = false;
    this.isBodySerialValid = '';

    let bodySerialPattern = /^[a-zA-Z]{3}-?[0-9]{6}$|^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/;
    let aspireBodySerialPattern = /^[A-Z]{7}[0-9]{8}$/;

    let icgPattern = /^(F|C)(A|B|C|D)(O|P|L|V|Q|W|R|T|U|C|Y|Z)(C|B|T|R)[0-9]{7}(-|A|B|C)(1[2-9]|2[0-9])[A-L]$/;

    let alphaNumbericPattern = /^[a-zA-Z0-9]$/;

    if (bodySerialPattern.test(bodySerial) || aspireBodySerialPattern.test(bodySerial)) {
      this.isBodySerialValid = 'true';
    } else if (this.bodySerial.length === 15) {
      if (this._addbodyserial.checkGlobalBodySerialFormat(bodySerial)) {
        this.isBodySerialValid = 'true';
      } else if (icgPattern.test(bodySerial)) {
        this.isBodySerialValid = 'true';
      } else {
        this.isBodySerialValid = 'false';
      }
    } else {
      this.isBodySerialValid = 'false';
    }
  }

  onCancel() {
    if (this.rootScopeData.isPageHasUnsavedChanges) {
      this.rootScopeData.showUnSavedChangesModal = true;
      this.rootScopeData.pathToNavigate = '/facility/equipment';
    } else {
      this.rootScopeData.isPageHasUnsavedChanges = false;
      this.router.navigate(['/facility/equipment']);
    }
  }

  goToZendesk(page: string): void {
    if (page === 'whereToFind') window.open('https://www.halo.fitness/web/app.html#/whereToFindThis', '_blank');
  }
  ngOnDestroy() {
    this.sub.unsubscribe();
  }
  onBack() {
    this.displayStep = 1;
  }

  save() {
    this.router.navigate(['/facility/equipment']);
    this.rootScopeData.isPageHasUnsavedChanges = false;
    // commented, user has to have permission when selecting multifacility 
    //const facilityId = this._facilityService.selectedFacilityId();
    //this._facilityService.updatedFacilityPreferenceForUser({ lastSelectedFacility: facilityId});
  }


  addBodySerial() {
    this.loader.startProcess();    
    this._ampAnalytics.logEvent({elementName: 'Add', action: 'Submit', additionalProperty: {subFeatureName: 'Add Old Equipment'}});
    const saveEquipmentSub = this._addbodyserial.saveEquipment(this.bodySerial,this.UUID,this.currentFacility.facilityId,this.connectedStrength).subscribe(
      async (data) => {
        // reset facility list
        try {
          this._facilityService.reset();
          await this._facilityService.get();
          this.save();
          this.multiFacService.resetMultiFacilitiesList();
          await this.multiFacService.getMultiFacilities();
          this._facilityService.menu();
        } catch (error) {
        }        
        this.loader.endProcess();
      },
      (error) => {
        this.loader.endProcess();
        console.error('API failed.',error);
        let errorMessage = error.error;
        // let errorCode = errorMessage.substring(errorMessage.indexOf('Code: ') + 6, errorMessage.indexOf('Code: ') + 9);
        if (errorMessage.toString().includes("307")) {
          this.serialNumberErrorType = 1;
          this.errorType = errorMessage.errorType;
          this.isSerialNumberError = true;
        } else if (errorMessage.toString().includes("308")) {
          this.serialNumberErrorType = 3;
          this.errorType = errorMessage.errorType;
          this.isSerialNumberError = true;
        } else if (errorMessage.toString().includes("309")) {
          this.rootScopeData.customPopupData = {
            title: 'OOPS',
            message: 'CUSTOM.LOADER.ERROR.MSG.ADD.EQUIPMENT',
            isWarningPopup: true,
            ctaButtonLabel: 'OK',
            isSecondaryTextButton: false,
            hideSecondaryButton: true
          }; 
          this.rootScopeData.showCustomModal = true;
          this.router.navigate(['/facility/equipment']);
          this.serialNumberErrorType = 2;
          this.errorType = errorMessage.errorType;
          this.isSerialNumberError = true;
        } else if (errorMessage.toString().includes("305")) {
          this.serialNumberErrorType = 5;
          this.errorType = errorMessage.errorType;
          this.isSerialNumberError = true;
        } else if (errorMessage.toString().includes("306")) {
          this.serialNumberErrorType = 6;
          this.errorType = errorMessage.errorType;
          this.isSerialNumberError = true;
        }
      }
    );
    this.sub.add(saveEquipmentSub);
  }

  bodySerialChangeRecorded(event: any) {
    this.setDraftedFlag();
  }
  setDraftedFlag(): void {
    this.rootScopeData.isPageHasUnsavedChanges = true;
  }

  generateImgSrcUrl(modelId: string, console: string) {
    return this.commonUtil.imgSrcGenerate(modelId, console, true);
  }
}
